"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = onDurationChange;
function onDurationChange(event) {
  // Only set current time if playback hasn't started, because otherwise it'd cause the video to restart
  if (!this.currentTime || this.currentTime <= 0) {
    this.setStartTimeForPlayable(this.currentPlayable, event.duration);
  }
  this.updateYouboraOptionsForCurrentPlayable();
  this.emit('durationchange', event);
}